export default __webpack_public_path__ + "static/gradient-background-0714e5643057c0e800771b5bfccb6f73.jpg";